module.exports = __webpack_public_path__ + "media/images/dummy-9bf1a767e04f256dbf53817fbe04510e.jpg";